import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmPasswordValidator } from './confirm-password.validator';
import { CommonModule } from '@angular/common';
import { AppService } from '../../../../../app.service';
import { AlertService } from '../../../../shared/alert/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  // standalone: true,
  // imports: [
  //   CommonModule,
  //   FormsModule,
  //   ReactiveFormsModule,
  //   MatStepperModule,
  //   MatFormFieldModule,
  //   MatInputModule,
  //   MatButtonModule,],

  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  @Output() onEmailSubmit: EventEmitter<string> = new EventEmitter();
  @Output() onCodeSubmit = new EventEmitter();
  @ViewChild('stepper') stepper!: MatStepper;
  @Input()
  emailSubmitted: boolean = false;
  matchPasswords: boolean = false
  @Input()
  passwordResetSuccessful: boolean = false;
  emailForm: FormGroup;
  confirmCodeForm: FormGroup;
  constructor(public fb: FormBuilder, public fb1: FormBuilder,
    public commonService: AppService,
    public alertService: AlertService,
    public router: Router) {
    this.emailForm = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
    });

    this.confirmCodeForm = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      confirmationCode: new FormControl('', [Validators.required]),
      password: ["", Validators.required],
      confirmPassword: ["", Validators.required]
    }
      , { validators: this.matchPassword }
    );
  }
  isLinear = false;


  matchPassword(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    if (password === confirmPassword) { return null }
    else {
      return { matchPassword: true }
    };
  }

  cancelEmail(){
    this.router.navigate(['/login']);
  }
  submitEmail() {
    if (this.emailForm.valid) {
      const email = this.emailForm.get('email')!.value;
      this.confirmCodeForm.get('email')!.setValue(email);
      this.onEmailSubmit.emit(email);
      this.confirmCodeForm.updateValueAndValidity();
      let payload = {
        "email": email
      }
      this.commonService.setEmail(email);
      let url = 'api/Auth/sendOTP';
      this.commonService.post(url, payload).subscribe({
        next: (res: any) => {
          this.alertService.success(res.message);
          this.router.navigate(['/login-otp'])
        },
        error: (err: any) => {
          this.alertService.error(err.error.message);
        }
      })
    }
  }

}
